import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ServicesOverview from '../components/ServicesOverview';
import Certification from '../components/Certification';
import CareerConsultation from '../components/CareerConsultation';
import CorporateTraining from '../components/CorporateTraining';
import HireTalent from '../components/HireTalent';
import WhyChoose from '../components/WhyChoose';
import Testimonials from '../components/Testimonials';
import SoftwareHighlight from '../components/SoftwareHighlight';
import SocialMedia from '../components/SocialMedia';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import BookSessionCTA from '../components/BookSessionCTA';
import SEOHead from '../components/SEOHead';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead title="CloudXAI Technologies - AI, Data & Cloud Training" description="CloudXAI Technologies is a private professional certification authority specializing in AI, Data, and Cloud technologies. Training, placement, and industry-certified credentials." path="/" />
      <Header />
      <HeroSection />
      <ServicesOverview />
      <BookSessionCTA />
      <Certification />
      <CareerConsultation />
      <CorporateTraining />
      <HireTalent />
      <WhyChoose />
      <Testimonials />
      <SoftwareHighlight />
      <SocialMedia />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;
